import React, { useState } from "react";
import AppNavigator from "../../../../components/AppNavigator";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const navigatorItems = [
  { value: "max", label: "Max Mustermann" },
  { value: "anna", label: "Anna Muster" },
  { value: "luca", label: "Luca Huber" },
  { value: "sara", label: "Sara Meier" },
];

const niceToKnowItems = [
  "Die Sizes SM und MD des Navigators richten sich nach den Button-Sizes.",
  "Placeholder setzen für Suchfeld im geöffneten Picker. (Default = Suchen...)",
  "Default für Empty Message nicht überschreiben (Keine Einträge vorhanden).",
  "Beim Öffnen wird die aktuelle Auswahl zentriert; vorherige Einträge liegen oberhalb und folgende Einträge unterhalb."
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

export default function NavigatorsDocs() {
  const [activeMd, setActiveMd] = useState("max");
  const [activeSm, setActiveSm] = useState("anna");

  return (
    <DocsSectionCard title="Navigators">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-navigator-preview">
            <PreviewRow label="MD">
              <AppNavigator
                items={navigatorItems}
                value={activeMd}
                onChange={(event) => setActiveMd(event.target.value)}
                className="ds-docs-navigator-preview__navigator"
              />
            </PreviewRow>

            <PreviewRow label="SM">
              <AppNavigator
                items={navigatorItems}
                size="sm"
                value={activeSm}
                searchPlaceholder="Lehrperson suchen"
                onChange={(event) => setActiveSm(event.target.value)}
                className="ds-docs-navigator-preview__navigator ds-docs-navigator-preview__navigator--sm"
              />
            </PreviewRow>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
